/**
 * Slider.js
 * Created on 08/17/2021.
 */

import React, {useContext, useState, useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import _ from 'lodash';
import {DocumentTypeIdContext} from '../../../../Main/Forms/CanvasFormContainer';
import {createUpdatePayloadForMultiSelectBody, createRequestURL} from '../Common/BodyResponseUtility';
import {formBodyType} from '../../../../../util/uiconstants';
import {labels, GetCardTypeForBody} from '../../../../../util/utils';
import {useDocumentId, useEngagementId} from '../../../../../util/customHooks';
import {useSelectedStEntityId} from '../../../../../util/Ares/customHooks';
import {getTaskDocumentByDocumentId} from '../../../../../selectors/Ares/selectors';
import BodyKnowledgeDescriptionContentSide from '../BodyKnowledgeDescriptionContentSide';
import BodyKnowledgeDescription from '../BodyKnowledgeDescription';
import ProgressBar from '../../../BaseComponentWrappers/MotifProgressBar';
import RiskFactorContainer from '../Common/RiskFactorContainer';
import ReactSlider from '../../../../Common/ReactSlider/ReactSlider';

export default function Slider(props) {
	const {
		isAresView,
		showGuidance,
		guidanceFilter,
		options,
		headerId,
		sectionId,
		bodyId,
		updateBodyOptions,
		getBodiesBySectionId,
		isSnapshotView,
		isDisabled,
		getMateriality
	} = props;

	const dispatch = useDispatch();
	const [selectedStEntityId] = useSelectedStEntityId();

	const [sliderBodyData, setSliderBodyData] = useState([]),
		[selectedBodyOption, setSelectedBodyOption] = useState([]);

	const engagementId = useEngagementId(),
		documentTypeId = useContext(DocumentTypeIdContext),
		documentId = useDocumentId();

	const reactSliderRef = useRef();

	const bodySelectedOptionIds = options.optionsAndResponses.find((bodies) => {
		if (isSnapshotView) {
			return bodies.bodySelectedOptionId > 0;
		}
		return bodies.bodyOptionId === bodies.bodySelectedOptionId;
	});

	const defaultSelectValue =
		bodySelectedOptionIds === undefined
			? 0
			: bodySelectedOptionIds.bodySelectedOptionId === bodySelectedOptionIds.bodyOptionId
			? {
					value: bodySelectedOptionIds.bodyOptionId,
					label: bodySelectedOptionIds.bodyOptionText,
					riskFactor: bodySelectedOptionIds.riskFactors
			  }
			: {
					value: 0,
					label: labels.select
			  };

	const aresFormData = useSelector((state) => getTaskDocumentByDocumentId(state, documentId));
	const formBodyDisplayData = useSelector((store) => store.formBodyDisplayData);

	let formStEntityId = aresFormData?.stEntityId;
	if (aresFormData && !formStEntityId) {
		formStEntityId = aresFormData.entities?.length > 0 ? aresFormData.entities[0] : undefined;
	}

	const selected = options.optionsAndResponses.filter((b) => b.bodyOptionId === b.bodySelectedOptionId);
	const formBodyBorder = GetCardTypeForBody(options, isAresView);

	const onChange = (e) => {
		document.getElementById(bodyId).classList.add('greyOutArea');
		const changed = e;
		let labelText = null;

		if (sliderBodyData && sliderBodyData.length > 0) {
			sliderBodyData.map((data) => {
				if (data.bodyOptionId === Number(changed)) {
					data.isChecked = !data.isChecked;
					labelText = data.bodyOptionText;
					setSelectedBodyOption(data);
				} else {
					data.isChecked = false;
				}
			});
			setSliderBodyData(sliderBodyData);
		}

		// Create body response
		const bodyResponseObject = createUpdatePayloadForMultiSelectBody(formBodyType.Slider, sliderBodyData);

		updateBodyOptions(
			bodyId,
			changed,
			createRequestURL(engagementId, documentId, headerId, sectionId, bodyId, documentTypeId),
			bodyResponseObject
		);
		reactSliderRef.current.onResponseCompleted(labelText || '');
	};

	const getRiskFactorContent = (selectedBodyOption, sectionId, bodyId) => {
		return (
			<>
				{selectedBodyOption[0] && selectedBodyOption[0].riskFactorList.length > 0 && (
					<RiskFactorContainer
						riskFactors={selectedBodyOption[0].riskFactorList}
						isVisible
						sectionId={sectionId}
						bodyId={bodyId}
						isViewBodyOnly={false}
					/>
				)}
			</>
		);
	};

	const getReactSliderContent = (options, bodyId) => {
		return (
			<ReactSlider
				max={options.optionsAndResponses[options.optionsAndResponses.length - 1].bodyOptionId}
				min={options.optionsAndResponses[0].bodyOptionId}
				value={options.optionsAndResponses}
				defaultValue={defaultSelectValue}
				onChange={onChange}
				bodyId={bodyId}
				ref={reactSliderRef}
				StyleName={'ReactSliderBody'}
				aresSlider={props.aresSlider}
				disabled={isDisabled}
			/>
		);
	};

	useEffect(() => {
		let bodyData = _.cloneDeep(options.optionsAndResponses);

		if (bodyData && bodyData.length > 0) {
			let filterBodyData = bodyData.map((obj) => ({
				...obj,
				isChecked: obj.bodyOptionId === obj.bodySelectedOptionId
			}));
			setSliderBodyData(filterBodyData);
		} else {
			setSliderBodyData([]);
		}
		setSelectedBodyOption(bodyData.filter((b) => b.bodyOptionId === b.bodySelectedOptionId));
	}, [options.optionsAndResponses]);

	useEffect(() => {
		if (
			options &&
			formBodyDisplayData &&
			options.id === formBodyDisplayData.id &&
			formBodyDisplayData.isMaterilityUpdate
		) {
			getMateriality();
		}
	}, [formBodyDisplayData, options, engagementId, dispatch]);

	return (
		<Wrapper
			className={`SectionBodyWrapper sectionBodySlider ${formBodyBorder} ${isAresView ? 'AresView' : 'KronosView'}`}
		>
			{options.optionsAndResponses && options.optionsAndResponses.length > 0 && options.cardTypeId === 1 ? (
				<>
					<BodyKnowledgeDescription
						isAresView={isAresView}
						showGuidance={showGuidance}
						guidanceFilter={guidanceFilter}
						isSnapshotView={isSnapshotView}
						bodyModel={options}
						engagementId={engagementId}
						documentId={documentId}
						headerId={headerId}
						sectionId={sectionId}
						bodyId={bodyId}
						bodyDescriptionText={options.name}
						cardTypeId={options.cardTypeId}
						isCustom={options.isCustom}
						isDuplicate={options.isDuplicate}
						getBodiesBySectionId={getBodiesBySectionId}
					/>
					<section
						className={`SectionBodyData SectionBodyDataSlider sliderbodiesWithCardType ${
							selected.length > 0 ? 'sliderSelected' : 'sliderNotSelected'
						}`}
						id={bodyId}
					>
						<section className="MotifProgressBarWrapper">
							<ProgressBar isIndeterminate circle hideLabel />
						</section>
						<section className="SectionBodySlider">{getReactSliderContent(options, bodyId)}</section>{' '}
					</section>
					{getRiskFactorContent(selectedBodyOption, sectionId, bodyId)}
				</>
			) : (
				<>
					{options.optionsAndResponses && options.optionsAndResponses.length > 0 && (
						<BodyKnowledgeDescriptionContentSide
							isAresView={isAresView}
							showGuidance={showGuidance}
							guidanceFilter={guidanceFilter}
							isSnapshotView={isSnapshotView}
							bodyModel={options}
							engagementId={engagementId}
							documentId={documentId}
							headerId={headerId}
							sectionId={sectionId}
							bodyId={bodyId}
							bodyDescriptionText={options.name}
							isCustom={options.isCustom}
							isDuplicate={options.isDuplicate}
							getBodiesBySectionId={getBodiesBySectionId}
						>
							<section className="SectionBodyData SectionBodyDataSlider" id={bodyId}>
								<section className="MotifProgressBarWrapper">
									<ProgressBar isIndeterminate circle hideLabel />
								</section>
								<section className="SectionBodySlider">{getReactSliderContent(options, bodyId)}</section>{' '}
							</section>
						</BodyKnowledgeDescriptionContentSide>
					)}
					{getRiskFactorContent(selectedBodyOption, sectionId, bodyId)}
				</>
			)}
		</Wrapper>
	);
}

const Wrapper = styled.section`
	display: block;
	&.AresView {
		.sliderbodiesWithCardType {
			width: 100%;
			background-color: var(--neutrals-00white);
			border-radius: var(--px-12);
			border: var(--px-1) solid var(--neutrals-200) !important;
			margin: var(--px-24) 0 0 0;
			padding: var(--px-60) var(--px-24) var(--px-40);
			height: var(--px-140);
			&.sliderNotSelected {
				padding: var(--px-40) var(--px-24);
			}
			.MotifProgressBarWrapper {
				top: 0;
				width: calc(100% - var(--px-30));
			}
			.SectionBodySlider {
				width: var(--px-400);
				white-space: nowrap;
				position: relative;
				top: calc(var(--px-5) * -1);
				section {
					margin-top: 0;
				}
				.ReactSliderBody {
					width: var(--px-400);
				}
				.railStyle,
				.railCenterStyle {
					background-color: var(--neutrals-700);
					height: 1px;
				}
				.slider-ticks {
					.tickSlider {
						background-color: var(--neutrals-700);
						height: var(--px-10);
						margin-top: calc(var(--px-5) * -1);
					}
					.tickSliderValue {
						font-size: var(--px-12);
						font-weight: 300;
						line-height: var(--px-16);
						color: var(--neutrals-700);
						width: 100%;
						margin-top: var(--px-13);
					}
				}
				.text-deselect {
					font-size: var(--px-14);
					font-weight: 300;
					line-height: var(--px-22);
					color: var(--neutrals-700);
				}
				.slider-handles {
					.HandleWrapper {
						.handleSlider {
							background-color: var(--neutrals-900);
							border-color: var(--neutrals-900);
						}
					}
					&.hideSelectorforAnswer {
						.HandleWrapper {
							.handleContainer {
								background-color: var(--neutrals-00white);
								border-radius: var(--px-10);
								.handleSlider {
									background-color: var(--neutrals-00white);
									border-color: var(--neutrals-900);
								}
							}
						}
					}
				}
			}
		}
		.SectionBodyDescription.SectionBodyDescription_Slider {
			padding-left: 0 !important;
			margin-left: 0 !important;
			margin-bottom: 0 !important;
			padding-bottom: 0 !important;
			.section-showless-header.SectionSliderHeader {
				* {
					font-size: var(--px-16) !important;
					font-weight: 300 !important;
				}
				.createRichTextElementSpanWrapper {
					ul,
					ol {
						margin-left: var(--px-20);
					}
				}
			}
		}
		.SectionBodyDataSlider {
			padding-left: 0 !important;
		}
		&.sectionBodySlider {
			.sectionBodyDescriptionContainer {
				width: calc(100% - var(--px-500));
				margin-top: var(--px-5);
			}
			.SectionSlider {
				.SectionBodyDataSlider {
					.SectionBodySlider {
						width: var(--px-500);
						& > section {
							margin: 0;
						}
						.slider-ticks {
							min-height: unset;
							.tickSliderLegendValue {
								font-size: var(--px-12) !important;
								font-weight: 300;
								line-height: var(--px-16) !important;
								color: var(--neutrals-700);
							}
						}
						.text-deselect {
							font-size: var(--px-14);
							font-weight: 300;
							line-height: var(--px-22);
							color: var(--neutrals-700);
						}
						.ReactSliderBody {
							.slider-handles {
								.handleContainer {
									.handleSlider {
										background-color: var(--neutrals-900);
										border-color: var(--neutrals-900);
									}
								}
							}
							.slider-ticks {
								.tickSliderValue {
									font-size: var(--px-12) !important;
									font-weight: 300;
									line-height: var(--px-16) !important;
									color: var(--neutrals-700);
								}
							}
						}
					}
				}
			}
		}
		&.sectionBodySliderLegend {
			.SectionBodyDataWrapper {
				.SectionBodyDataSliderLegend {
					.SectionBodySliderLegends {
						.slider-ticks {
							.tickSliderLegendValue {
								line-height: var(--px-16) !important;
							}
						}
					}
				}
			}
		}
	}
	&.sectionBodySlider {
		min-height: var(--px-110);
		.section-showless-header {
			width: calc(100% - var(--px-515));
			line-height: var(--px-20);
			white-space: nowrap;
			&.SectionSliderHeader {
				width: 100% !important;
				white-space: break-spaces;
			}
		}
	}
	.SectionBodyDataWrapper {
		margin-left: auto;
		margin-top: var(--px-10);
	}
	.SectionBodyData {
		flex-direction: unset !important;
		padding: 0;
		width: var(--px-500);
		position: relative;
		.MotifProgressBarWrapper {
			display: none;
			position: absolute;
			justify-content: center;
			width: 80%;
			height: 100%;
			.motif-progress-bar-wrapper {
				height: 100%;
				z-index: 1;
				justify-content: center;
				span {
					color: var(--green-500);
					font-size: var(--px-12);
				}
				.motif-progress {
					background-color: var(--green-500);
				}
				.motif-progress-bar {
					height: var(--px-30);
					width: var(--px-30);
					svg path {
						fill: none !important;
					}
				}
			}
		}
		.SectionBodySlider {
			flex-direction: column;
			.hideSelectorforAnswer {
				.handleSlider {
					background: var(--neutrals-00white);
					border: var(--px-1) solid var(--neutrals-300);
					box-shadow: none;
				}
			}
			.deselectSelectorforAnswer {
				background-color: var(--neutrals-300);
			}
			.deselectSelectorforTicks {
				color: var(--neutrals-300);
			}
		}
	}
`;
